import React from 'react';
import styled from 'styled-components';
import { colors } from '../utils/colors';

const Parrafo = styled.p`
	max-width: 650px;
	margin: 0 auto;
	text-align: left;
	padding: 1em 0 1em 0;
	font-family: 'D-DinExp';
	letter-spacing: 0.01rem;
	color: ${colors.white};
`;

const Copy = ({ contenido }) => (
	<div>
		<Parrafo>{contenido}</Parrafo>
	</div>
);

export default Copy;



// WEBPACK FOOTER //
// ./src/components/Copy.js